import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

export const WarrantyTableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      key: "category",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.CATEGORY"),
      render: (category: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {category || "..."}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "group",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.GROUP"),
      render: (group: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {group || "..."}
          </Text>
        );
      },
    },

    {
      id: 4,
      key: "brand",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.BRAND"),
      render: (brand: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {brand || "..."}
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "product",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.NAME"),
      render: (product: string) => {
        return (
          <Text className="text-nowrap text-info" weight="semibold">{product || "..."}</Text>
        );
      },
    },
    {
      id: 6,
      key: "lotNo",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.LOT_NO"),
      render: (data: number) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {data}
          </Text>
        );
      },
    },
    {
      id: 7,
      key: "barcode",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.BARCODE"),
      render: (barcode: number) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {barcode ? barcode : "..."}
          </Text>
        );
      },
    },
    {
      id: 8,
      className: "text-nowrap",
      key: "warrantyStartDate",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.WARRANTY_START"),
      render: (warrantyStartDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {warrantyStartDate ? dayjs(warrantyStartDate).format("DD-MM-YYYY") : "..."}
          </Text>
        );
      },
    },

    {
      id: 9,
      className: "text-nowrap",
      key: "warrantyEndDate",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.WARRANTY_END"),
      render: (warrantyEndDate: string) => {
        return (
          <Text color="warning" className="text-nowrap">
            {warrantyEndDate ? dayjs(warrantyEndDate).format("DD-MM-YYYY") : "..."}
          </Text>
        );
      },
    },
    {
      id: 10,
      className: "text-nowrap",
      key: "purchaseDate",
      name: t("INVENTORY_WARRANTY.TABLE.COLUMN.PURCHASE_DATE"),
      render: (purchaseDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {purchaseDate}
          </Text>
        );
      },
    },
    {
      id: 11,
      key: "",
      name: "",
      render: (data: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {data}
          </Text>
        );
      },
    },
  ];
};
